/**
 * AdminGuard — Outlet adapter so the existing `<Route element={<AdminGuard/>}>`
 * layout-route wiring (App.tsx) keeps working. All logic lives in
 * RequireAdminAuth (STORY-008-006 refactor of the prior single-slug guard).
 */
import { type ReactElement } from "react";
import { Outlet } from "react-router-dom";

import { RequireAdminAuth } from "@/features/admin/RequireAdminAuth";

export function AdminGuard(): ReactElement {
  return (
    <RequireAdminAuth>
      <Outlet />
    </RequireAdminAuth>
  );
}

export default AdminGuard;
